module.exports = __webpack_public_path__ + "static/media/soldier_box.989766b1.png";